

<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  data(){
    return {
      url: this.$store.state.url,
      schoolId: this.$store.state.schoolId,
      data:[]
    }
  },  
  async mounted() {

    await this.getReport()


    this.renderChart(
      {
        labels: [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre"
        ],
        datasets: [
          {
            label: "Comparativa de Asistencia por Mes",
            backgroundColor: "rgba(0,0,0,0.35)",
            fontColor: "#ff0000",
            data: this.data
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontColor: "#fff",            
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              fontColor: '#fff'
            },
          }],
          xAxes: [{
            ticks: {
              fontColor: '#fff'
            },
          }]
        }
      }
    );
  },
  methods:{
    async getReport(){
      const y = new Date().getFullYear()
      let url = this.url + "getYearlyReport/" + this.schoolId + "/" + y      
      let req = await fetch(url)

      if (!req.ok){
        this.$emit("error")
        return
      }

      this.data = await req.json()

    }
  }
};
</script>

<style>
</style>